import React from 'react';
import Styled from './styled';
import { TicketsType } from './TicketsType';
// import useTranslate from '../../../../hooks/useTranslate';

export const AnnouncementItem = ({ title, subtitle, children, announcementType, ticketType }) => {
  // const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  // const detailsListToggle = useCallback(() => setIsDetailsOpen((s) => !s), []);
  // const { t } = useTranslate();

  return (
    <article>
      <Styled.AnnouncementItem>
        <Styled.Header>
          <Styled.Title>{title}</Styled.Title>
          {subtitle}
        </Styled.Header>

        {/* <Styled.Center>
          <Styled.IsBrokerTicket>{t('announcements_broker_ticket_count')}</Styled.IsBrokerTicket>
        </Styled.Center> */}
        <TicketsType announcementType={announcementType} ticketType={ticketType} />
        <Styled.FlexHelper>
          {/* <Styled.DetailBtn isActive={isDetailsOpen} onClick={detailsListToggle} type="button">
            Детали
          </Styled.DetailBtn> */}

          {children}
        </Styled.FlexHelper>
      </Styled.AnnouncementItem>
      {}

      {/* {isDetailsOpen && <Details />} */}
    </article>
  );
};

// const Details = () => {
//   return (
//     <Styled.Details>
//       <Styled.DetailsList>
//         <Styled.DetailItem type="goodView">Хороший вид</Styled.DetailItem>
//         <Styled.DetailItem type="speed">Мгновенная доставка</Styled.DetailItem>
//         <Styled.DetailItem type="wifi">Электронный билет</Styled.DetailItem>
//         <Styled.DetailItem type="fiveStar">Проверенный продавец</Styled.DetailItem>
//         <Styled.DetailItem type="invalid">Подходит инвалидам</Styled.DetailItem>
//       </Styled.DetailsList>
//     </Styled.Details>
//   );
// };
